import { MentionNodeAttrs } from '@tiptap/extension-mention';
import { ReactRenderer } from '@tiptap/react';
import { SuggestionKeyDownProps, SuggestionProps } from '@tiptap/suggestion';
import tippy, { Instance, Props } from 'tippy.js';

import { KeyboardKeys } from '@/shared/utils/navigation';

import { Z_INDEXES } from '@/utils/constants';

import { MentionItem } from '../types/rich-text-editor';
import MentionList from './mention-list';

interface SuggestionRenderProps extends SuggestionProps<MentionItem, MentionNodeAttrs> {}

export default function getSuggestions() {
	return {
		render: () => {
			let component: ReactRenderer;
			let popup: Instance<Props>[];

			return {
				char: '{',
				onStart: (props: SuggestionRenderProps) => {
					component = new ReactRenderer(MentionList, {
						props,
						editor: props.editor,
					});

					if (!props.clientRect) return;

					popup = tippy('body', {
						getReferenceClientRect: props.clientRect as () => DOMRect,
						appendTo: () => document.body,
						content: component.element,
						showOnCreate: true,
						interactive: true,
						trigger: 'manual',
						placement: 'bottom-start',
						zIndex: Z_INDEXES.TIPPY,
					});
				},

				onUpdate(props: SuggestionRenderProps) {
					component.updateProps(props);

					if (!props.clientRect) {
						return;
					}

					popup[0].setProps({
						getReferenceClientRect: props.clientRect as () => DOMRect,
					});
				},

				onKeyDown(props: SuggestionKeyDownProps) {
					if (props.event?.key === KeyboardKeys.Escape) {
						popup[0].hide();

						return true;
					}

					return (component.ref as { onKeyDown: (props: KeyboardEvent) => boolean })?.onKeyDown(
						props?.event
					);
				},

				onExit() {
					popup[0].destroy();
					component.destroy();
				},
			};
		},
	};
}
